import { ApiErrorTranslationKeys } from '@/lib/api/apiErrorTranslationKeys.ts';

/**
 * Backend error keys specific to tour options. Detect these on 400 responses
 * with `isKnownBackendErrorKey` to show tailored messages to the user.
 *
 * Values are `TranslationKey` enum member names — see `hasErrorKey` for why the
 * dotted variant (`error.tour_option.in_use`) never matches.
 */
export const TourOptionErrorKeys = {
  /** DELETE was attempted on an option referenced by bookings or change packages. */
  OPTION_IN_USE: 'TOUR_OPTION_IN_USE',
  /** PUT tried to remove a variant referenced by bookings or change packages. */
  VARIANT_IN_USE: 'TOUR_OPTION_VARIANT_IN_USE',
  /** PUT tried to remove a price row referenced by bookings or change packages. */
  PRICE_IN_USE: 'TOUR_OPTION_PRICE_IN_USE',
} as const satisfies Record<string, keyof typeof ApiErrorTranslationKeys>;
